module.exports = __webpack_public_path__ + "8fe265272912b61d6512aa418b67ba28.svg";